import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

const noop = () => {};

export const SELECT_AUTOCOMPLETE_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectAutocompleteComponent),
  multi: true,
};

@Component({
  selector: 'select-autocomplete',
  templateUrl: './select-autocomplete.component.html',
  styleUrls: ['./select-autocomplete.component.scss'],
  providers: [SELECT_AUTOCOMPLETE_CONTROL_VALUE_ACCESSOR],
})
export class SelectAutocompleteComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input()
  label: string;
  @Input()
  placeholder = 'Zoek';
  @Input()
  options: any[] = [];
  @Input()
  filterFunction: (key: string, option: any) => boolean = (k, o) => {
    return String(o).includes(k);
  };
  @Input()
  displayOption: (option: any) => string = (o) => {
    return String(o);
  };
  @Input()
  disabled = false;

  @ViewChild('autocomplete')
  inputRef: ElementRef<HTMLInputElement>;

  private innerValue: any = undefined;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  init = false;

  filterControl = new UntypedFormControl();

  filteredOptions: any[];

  ngOnInit() {
    this.setFilteredOptions();
    this.addSubscription(this.filterControl.valueChanges, (value: string) => {
      this.filteredOptions =
        this.options == null
          ? []
          : this.options.filter((o) => {
              return this.filterFunction(value, o);
            });
    });
    this.init = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options) {
      this.setFilteredOptions();
    }
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  setFilteredOptions() {
    this.filterControl.setValue('');
    this.filteredOptions = this.options == null ? [] : [...this.options];
  }

  onPanelOpen() {
    if (this.inputRef != null && this.inputRef.nativeElement != null) {
      this.inputRef.nativeElement.focus();
    }
  }

  onPanelClose() {
    this.filterControl.setValue('');
  }
}
